import { AppPaths } from "@app/router/paths";
import { LIST_FILTER_QUERY_PARAM } from "@app/router/queryParams";
import { buildUrl } from "@shared/utils/buildUrl";
import { serializeBase64Json } from "@shared/utils/url/parsers/parseAsBase64Json";
import { StockKanbanComplectState, type StockKanbanContainerFilter } from "../../../../api/stockKanbanContainers";

/**
 * Deep-link на список контейнеров КАНБАН по подразделению-потребителю: все статусы
 * комплектования, без отбора по комплектовщику. \
 * Используется карточкой после завершения комплектования: пользователь попадает
 * на свежую выборку потребителя завершённого контейнера независимо от прошлого фильтра.
 * @param divisionCode код подразделения-потребителя
 */
export function buildStockKanbanSupplyDivisionListUrl(divisionCode: number): string {
    const filter: StockKanbanContainerFilter = {
        DivisionCodes: [divisionCode],
        ComplectStates: [
            StockKanbanComplectState.Idle,
            StockKanbanComplectState.InProgress,
            StockKanbanComplectState.Finished,
        ],
    };

    return buildUrl(AppPaths.STOCK.KANBAN_SUPPLY.LIST, {
        [LIST_FILTER_QUERY_PARAM]: serializeBase64Json(filter),
    });
}
